import { SearchTerm } from "./SearchTerm";

const EmailAccountSearch: SearchTerm[] = [
    {
        heading: "Email Account",
        accessor: "name",
        searchOnName: "accName",
        translationKey: "emailAccount"
    },
    {
        heading: "Outgoing Server",
        accessor: "outgoingServer",
        searchOnName: "outgoingServer",
        translationKey: "outgoingServer"
    },
    {
        heading: "Username",
        accessor: "username",
        searchOnName: "username",
        translationKey: "username"
    },
    {
        heading: "Port Number",
        accessor: "portNumber",
        searchOnName: "portNumber",
        translationKey: "portNumber"
    }
];

export default EmailAccountSearch;
